import React from 'react';
import styled from '@emotion/styled';
import 'external-svg-loader';

import { Config, StyleLibrary } from '@vm/omega-shared-component-webapp';
const { mqBreakpoints, pxToRem } = StyleLibrary;

// This CSS gives an angled pattern 45% to the right

const BackgroundPatternContainer = styled.div({
  position: 'absolute',
  overflow: 'hidden',
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
  // z-index is -1 here to ensure the pattern is behind the title and description
  zIndex: '-1 !important' as string,
});

const BackgroundPatternSvg = styled.svg({
  position: 'absolute',
  transform: 'translate(-50%, -50%) rotate(-135deg)',
  // don't show for mobile and tablet
  left: 0,
  top: 0,
  width: pxToRem(0),
  height: pxToRem(0),

  [mqBreakpoints.desktop]: {
    left: '21.5%',
    top: pxToRem(1760),
    width: pxToRem(768),
    height: pxToRem(5429),
  },
});

export const TilesBackgroundPattern: React.FC = () => {
  return (
    <>
      <BackgroundPatternContainer>
        <BackgroundPatternSvg
          data-src={`${Config.get('image_cdn_base_url')}/ui/product-marketplace-webapp/vertical-pattern.svg`}
          style={{
            color: 'var(--color-secondary-2)',
            opacity: 0.5,
          }}
          data-testid={'mp-tile-bg-svg-l'}
        />
      </BackgroundPatternContainer>
    </>
  );
};
